module.exports = __webpack_public_path__ + "static/media/BecomeGuildIcon.b5640974.svg";